export default __webpack_public_path__ + "static/media/plus-circle.40dd990b.svg";